<template>
    <div>
        <empty-table-message v-if="isEmpty" />
        <div v-else>
            <div class="is-flex is-flex-hright is-flex-vcenter g-6 mb-2">
                <h3>
                    <strong>
                        SALDO TOTAL: {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(saldoTotal) }}
                    </strong>
                </h3>
                <button
                    class="save-btn w-150"
                    type="button"
                    tag="button"
                    :disabled="saldosSelecionados.length < 1"
                    @click="$emit('showModalFlexGerenciaSaldoManage')"
                >
                    {{ $t('gerenciar-saldo') }}
                </button>
            </div>
            <b-table
                :data="saldos"
                class="data-table table-overflow"
                @sort="sortTable"
                backend-sorting
                striped
                hoverable
                :checked-rows.sync="saldosSelecionados"
                :custom-is-checked="(selecionado, saldo) => selecionado.id === saldo.id"
                checkbox-type="is-primary"
                checkable
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.label)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :visible="f.visible"
                    v-slot="props"
                    :header-class="f.key == 'label' && !isMobile() ? 'remove-space' : ''"
                    :cell-class="f.key == 'label' && !isMobile() ? 'remove-space' : ''"
                >
                    <template v-if="f.key === 'dataHora'">
                            {{ props.row[f.key] ? $moment(props.row[f.key]).format("L LT") : "--" }}
                    </template>
                    <template v-else-if="f.key === 'tipoPedido'">
                        {{ props.row.pedido.tipopedido }}
                    </template>
                    <template v-else-if="f.key === 'valorPedido'">
                        <p 
                            :class="{ 'is-debit': props.row.pedido.valortotal < 0 }"
                        >
                            {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.row.pedido.valortotal) }}
                        </p>
                    </template>
                    <template v-else-if="f.key === 'saldoGerado'">
                        <p 
                            :class="{ 'is-debit': props.row[f.key] < 0 }"
                        >
                            {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.row[f.key]) }}
                        </p>
                    </template>
                    <template v-else>
                        {{ props.row[f.key] }}
                    </template>
                </b-table-column>

                <template v-if="saldosSelecionados.length > 0" #bottom-left>
                    <h3>
                        <strong>
                            SALDO TOTAL SELECIONADO: 
                            <span :class="{ 'is-debit': saldoTotalSelecionado < 0 }">
                                {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(saldoTotalSelecionado) }}
                            </span>
                        </strong>
                    </h3>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BloqueadoTable',

    props: {
        saldos: {
            type: Array,
            default: (_) => [],
        },
        saldoTotal: {
            type: Number,
            default: 0
        },
        isMobile: {
            type: Function,
            default: () => {},
        },
        sortTable: {
            type: Function,
            default: () => {},
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
        }
    },
    watch: {
        saldosSelecionados() {
            this.saldoTotalSelecionado = this.saldosSelecionados.reduce((acc, currentValue) => acc + currentValue.saldoGerado, 0);

            this.$emit("updateCheckeds", this.saldosSelecionados);
        }
    },
    data() {
        return {
            fields: [
                { key: 'idPedido', label: 'pedido', width: null, sortable: true, visible: true },
                { key: 'dataHora', label: 'data-hora', width: null, sortable: true, visible: true },
                { key: 'nomeCliente', label: 'cliente', width: null, sortable: true, visible: true },
                { key: 'tipoPedido', label: 'tipo-pedido', width: null, sortable: true, visible: true },
                { key: 'nomePrazo', label: 'prazo-pagamento', width: null, sortable: true, visible: true },
                { key: 'nomeForma', label: 'forma-pagamento', width: null, sortable: true, visible: true },
                { key: 'valorPedido', label: 'valor-pedido', width: null, sortable: true, visible: true },
                { key: 'saldoGerado', label: 'saldo-flex', width: null, sortable: true, visible: true },
            ],
            saldoTotalSelecionado: 0,
            saldosSelecionados: [],
        };
    },
    methods: {
        clearSaldosSelecionados() {
            this.saldosSelecionados = [];
        }
    }
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-overflow {
        .table {
            min-width: 990px;
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.w-150 {
    width: 150px;
}
.g-6 {
    gap: 24px;
}
.is-debit {
    color: #F44336;
}
.g-2 {
    gap: 8px;
}
// Barra de filtro
.label-situacao {
    position: absolute;
    bottom: 5px;
    top: 5px;
    display: flex;

    .bar {
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        height: 100%;
        &.bar-finalizada {
            background-color: #84bd42;
        }
        &.bar-aberta {
            background-color: #fd5858;
        }
    }
}
.sovis-tag {
    display: inline-block;
    text-transform: capitalize;
    text-align: center;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #fff;
    margin: 1px;
    cursor: pointer;

    &.is-success {
        background-color: $green-alert;
    }
    &.is-danger {
        background-color: $orange;
    }
}
.sovis-container-user {
    cursor: pointer;
    padding: 2px 10px;
    border: solid 1px $primary-color;
    background-color: #f0f0f0;
    border-radius: 6px;
    display: flex;
    position: absolute;
    @media screen and (max-width: 850px) {
        position: relative;
    }
    .qtd-users {
        font-weight: bolder;
        font-size: 18px;
        margin: 0 10px;
        &.is-success {
            color: $green-alert;
        }
        &.is-danger {
            color: $orange;
        }
    }
}
</style>
